/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetCreditLedgerCustomerIdParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest,
  TrainWithMeModulesBookingDtosResponsesCreditLedgerResponse,
  TrainWithMeModulesBookingDtosResponsesCreditLedgerSummaryResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreditLedgerSummary = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesCreditLedgerSummaryResponse>(
      {url: `/credit-ledger/summary`, method: 'GET', signal
    },
      options);
    }




export const getGetCreditLedgerSummaryQueryKey = () => {
    return [
    `/credit-ledger/summary`
    ] as const;
    }


export const getGetCreditLedgerSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditLedgerSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditLedgerSummary>>> = ({ signal }) => getCreditLedgerSummary(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditLedgerSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditLedgerSummary>>>
export type GetCreditLedgerSummaryQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetCreditLedgerSummary<TData = Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditLedgerSummary>>,
          TError,
          Awaited<ReturnType<typeof getCreditLedgerSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerSummary<TData = Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditLedgerSummary>>,
          TError,
          Awaited<ReturnType<typeof getCreditLedgerSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerSummary<TData = Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCreditLedgerSummary<TData = Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditLedgerSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreditLedgerCustomerId = (
    customerId: number,
    params?: GetCreditLedgerCustomerIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesCreditLedgerResponse>(
      {url: `/credit-ledger/${customerId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCreditLedgerCustomerIdQueryKey = (customerId: number,
    params?: GetCreditLedgerCustomerIdParams,) => {
    return [
    `/credit-ledger/${customerId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCreditLedgerCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(customerId: number,
    params?: GetCreditLedgerCustomerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditLedgerCustomerIdQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>> = ({ signal }) => getCreditLedgerCustomerId(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreditLedgerCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>>
export type GetCreditLedgerCustomerIdQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetCreditLedgerCustomerId<TData = Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params: undefined |  GetCreditLedgerCustomerIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditLedgerCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCreditLedgerCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerCustomerId<TData = Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetCreditLedgerCustomerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditLedgerCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCreditLedgerCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreditLedgerCustomerId<TData = Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetCreditLedgerCustomerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCreditLedgerCustomerId<TData = Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetCreditLedgerCustomerIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreditLedgerCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreditLedgerCustomerIdQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCreditLedgerCustomerIdAdjustment = (
    customerId: number,
    trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesCreditLedgerResponse>(
      {url: `/credit-ledger/${customerId}/adjustment`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest, signal
    },
      options);
    }




export const getPostCreditLedgerCustomerIdAdjustmentMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdAdjustment>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdAdjustment>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext> => {

const mutationKey = ['postCreditLedgerCustomerIdAdjustment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreditLedgerCustomerIdAdjustment>>, {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}> = (props) => {
          const {customerId,data} = props ?? {};

          return  postCreditLedgerCustomerIdAdjustment(customerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCreditLedgerCustomerIdAdjustmentMutationResult = NonNullable<Awaited<ReturnType<typeof postCreditLedgerCustomerIdAdjustment>>>
    export type PostCreditLedgerCustomerIdAdjustmentMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest> | undefined
    export type PostCreditLedgerCustomerIdAdjustmentMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostCreditLedgerCustomerIdAdjustment = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdAdjustment>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCreditLedgerCustomerIdAdjustment>>,
        TError,
        {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>},
        TContext
      > => {
      return useMutation(getPostCreditLedgerCustomerIdAdjustmentMutationOptions(options), queryClient);
    }
    export const postCreditLedgerCustomerIdForgiveness = (
    customerId: number,
    trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesCreditLedgerResponse>(
      {url: `/credit-ledger/${customerId}/forgiveness`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest, signal
    },
      options);
    }




export const getPostCreditLedgerCustomerIdForgivenessMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdForgiveness>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdForgiveness>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext> => {

const mutationKey = ['postCreditLedgerCustomerIdForgiveness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreditLedgerCustomerIdForgiveness>>, {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}> = (props) => {
          const {customerId,data} = props ?? {};

          return  postCreditLedgerCustomerIdForgiveness(customerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCreditLedgerCustomerIdForgivenessMutationResult = NonNullable<Awaited<ReturnType<typeof postCreditLedgerCustomerIdForgiveness>>>
    export type PostCreditLedgerCustomerIdForgivenessMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest> | undefined
    export type PostCreditLedgerCustomerIdForgivenessMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostCreditLedgerCustomerIdForgiveness = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdForgiveness>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCreditLedgerCustomerIdForgiveness>>,
        TError,
        {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>},
        TContext
      > => {
      return useMutation(getPostCreditLedgerCustomerIdForgivenessMutationOptions(options), queryClient);
    }
    export const postCreditLedgerCustomerIdGrant = (
    customerId: number,
    trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesCreditLedgerResponse>(
      {url: `/credit-ledger/${customerId}/grant`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest, signal
    },
      options);
    }




export const getPostCreditLedgerCustomerIdGrantMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdGrant>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdGrant>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext> => {

const mutationKey = ['postCreditLedgerCustomerIdGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreditLedgerCustomerIdGrant>>, {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}> = (props) => {
          const {customerId,data} = props ?? {};

          return  postCreditLedgerCustomerIdGrant(customerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCreditLedgerCustomerIdGrantMutationResult = NonNullable<Awaited<ReturnType<typeof postCreditLedgerCustomerIdGrant>>>
    export type PostCreditLedgerCustomerIdGrantMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest> | undefined
    export type PostCreditLedgerCustomerIdGrantMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostCreditLedgerCustomerIdGrant = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdGrant>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCreditLedgerCustomerIdGrant>>,
        TError,
        {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>},
        TContext
      > => {
      return useMutation(getPostCreditLedgerCustomerIdGrantMutationOptions(options), queryClient);
    }
    export const postCreditLedgerCustomerIdSettlement = (
    customerId: number,
    trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesCreditLedgerResponse>(
      {url: `/credit-ledger/${customerId}/settlement`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest, signal
    },
      options);
    }




export const getPostCreditLedgerCustomerIdSettlementMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdSettlement>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdSettlement>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext> => {

const mutationKey = ['postCreditLedgerCustomerIdSettlement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreditLedgerCustomerIdSettlement>>, {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}> = (props) => {
          const {customerId,data} = props ?? {};

          return  postCreditLedgerCustomerIdSettlement(customerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCreditLedgerCustomerIdSettlementMutationResult = NonNullable<Awaited<ReturnType<typeof postCreditLedgerCustomerIdSettlement>>>
    export type PostCreditLedgerCustomerIdSettlementMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest> | undefined
    export type PostCreditLedgerCustomerIdSettlementMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostCreditLedgerCustomerIdSettlement = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditLedgerCustomerIdSettlement>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCreditLedgerCustomerIdSettlement>>,
        TError,
        {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPostCreditLedgerEntryRequest>},
        TContext
      > => {
      return useMutation(getPostCreditLedgerCustomerIdSettlementMutationOptions(options), queryClient);
    }
